import * as types from '../actions/types'
import get from 'lodash.get';

const projectsReducer = (state = {}, action) => {
    switch(action.type) {
        case types.FETCH_PROJECTS_SUCCESS:
            const projectsById = changeProjectStructure(action.projects);
            return { ...state, projects: action.projects, projectsById: projectsById };
        case types.PROJECTS_FILTER_UPDATE:
            const projectCategory = (get(state, 'filter') === action.projectCategory || action.projectCategory === undefined) ? undefined : action.projectCategory;
            return { ...state, filter: projectCategory };
        default:
            return state;
    }
}

function changeProjectStructure(projects) {
    var structuredProjects = {};

    projects.map((project, index) => {
        return (
            structuredProjects[project.id] = {
                ...project
            }
        )
    });

    return structuredProjects;
}

export default projectsReducer;


// WEBPACK FOOTER //
// ./src/reducers/projectsReducer.js